import React, { useEffect, useState } from "react";
import { DoctorComponent } from "../common";
import { Typography, useTheme } from "@material-ui/core";
import { useInfoComponentStyles } from "../../styles/info-component-style";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import InfoData from "./info-data";
import CancelIcon from "@material-ui/icons/Cancel";

const InfoComponent = ({ stage, info, setInfo }) => {
  const classes = useInfoComponentStyles();
  const theme = useTheme();
  const isWidthXs = useMediaQuery(theme.breakpoints.down("xs"));
  const [displayIndex, setDisplayIndex] = useState(0);
  const stageList = InfoData();
  const chosenIndex = stageList[stage] ? stageList[stage][displayIndex] : null;

  const desktopHighlightArr = stageList[stage]
    ? chosenIndex.desktopHighlightId
    : null;

  const handleClick = (type) => {
    let el = document.getElementById("card");
    el.style.opacity = "0";

    if (chosenIndex.independentRoot) {
      highlight({ zIndex: 10, opacity: 1 }); //restore the opacity
    } else highlight({ zIndex: 1 }); //off the highlight

    if (type === "proceed") {
      //proceed to the next index
      if (displayIndex === stageList[stage].length - 1) {
        //close the dialog box
        setInfo(false);
        setDisplayIndex(0);
      } else {
        setTimeout(() => {
          el.style.opacity = "1";
          setDisplayIndex(displayIndex + 1);
        }, 100);
      }
    } else {
      //close the dialog box when cross button is clicked
      setInfo(false);
      setDisplayIndex(0);
    }
  };

  const highlight = ({ zIndex, opacity }) => {
    if (desktopHighlightArr || chosenIndex.independentRoot) {
      if (chosenIndex.independentRoot) {
        //for bottom nav bar and header component only
        let el = document.getElementById(chosenIndex.independentRoot);
        if (el) el.style.zIndex = zIndex; //bring bottom nav bar to front (zIndex:12) or back (zIndex:10)

        let hiddenArr = chosenIndex.desktopHiddenId;
        hiddenArr.forEach((id) => {
          // reduce (opacity:0.3) or restore (opacity:1) opacity of unneeded button
          let el = document.getElementById(id);
          if (el) el.style.opacity = opacity;
        });
      } else {
        desktopHighlightArr.forEach((id) => {
          setTimeout(() => {
            let el = document.getElementById(id.toString());
            if (el) {
              el.style.zIndex = zIndex;
            }
          }, 250);
        });
      }
    }
  };

  useEffect(() => {
    let el = document.getElementById("card");
    if (el) el.style.opacity = "0";
    setTimeout(() => {
      if (document.getElementById("card"))
        document.getElementById("card").style.opacity = "1";
    }, 10);
  });

  //current zIndex order from highest to lowest
  //doctor, 15, transparent background + card, 14
  //highlighted component, 12, dark background, 11
  //original bottom navbar and header, 10

  return (
    <React.Fragment>
      {info && stageList[stage] ? (
        <div>
          <DoctorComponent //when the card is located at the bottom and the screen is small, hide the doctor
            klass={
              isWidthXs &&
              (chosenIndex.card === classes.cardAtBottom ||
                chosenIndex.card === classes.cardRightDown ||
                chosenIndex.card === classes.cardLeftDown ||
                chosenIndex.card === classes.cardBottomRight ||
                chosenIndex.card === classes.cardAtBottomEvaluation ||
                chosenIndex.hideDoctorWhenSmall)
                ? classes.hideDoctor
                : chosenIndex.doctor
            }
          />
          <div className={classes.background}>
            <div
              style={{
                backgroundColor: "#d1d1d1",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                boxShadow:
                  "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
                transition: "opacity .3s ease",
                opacity: "0",
              }}
              className={chosenIndex.card}
              id="card"
            >
              <div className={classes.contents}>
                <div className={classes.textContainer}>
                  <Typography className={classes.text}>
                    {chosenIndex.text}
                  </Typography>
                </div>
                <div
                  className={classes.cross}
                  style={{
                    display:
                      displayIndex === stageList[stage].length - 1
                        ? "none"
                        : "block",
                  }}
                >
                  <CancelIcon
                    className={classes.close}
                    onClick={() => {
                      handleClick("close");
                    }}
                  />
                </div>
              </div>
              <Typography className={classes.proceed}>
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    handleClick("proceed");
                  }}
                >
                  {displayIndex === stageList[stage].length - 1
                    ? "Done >"
                    : "Next >"}
                </div>
              </Typography>
            </div>
          </div>
          <div className={classes.canvas} />
          {highlight({ zIndex: 12, opacity: 0.3 })}
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default InfoComponent;
